import {
  ErrorDialogContext,
  errorHandledAsync,
  errorHandledSync,
} from "@/shared/context/error-context";
import { AddAccountGroupsService } from "@/features/accounts/account-group/services/add-account-groups-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useAddAccountGroupsStates } from "@/features/accounts/account-group/hooks/use-add-account-groups-states";
import { useContext } from "react";
import { RegisteredAccount } from "@/features/accounts/account-group/services/add-account-groups-model";

interface Props {
  onTapCompleteModal: () => void;
}

export const useAddAccountGroups = ({ onTapCompleteModal }: Props) => {
  const {
    accountGroupName,
    setAccountGroupName,
    isActivateCreateButton,
    setIsActivateCreateButton,
    registeredAccounts,
    setRegisteredAccounts,
    check,
    setCheck,
  } = useAddAccountGroupsStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const addAccountGroupsService = new AddAccountGroupsService();

  const onChangeGroupName = (value: string) => {
    setAccountGroupName(value);
  }

  const onChangeCreateButtonState = (value: string) => {
    setIsActivateCreateButton(value !== "");
  }

  const onTapCheckBox = () => {
    if (check) {
      setCheck(false);
    } else {
      setCheck(true);
    }
  };

  // 口座グループ追加
  const addAccountGroups = async (
    accountGroupName: string,
    registeredAccounts: RegisteredAccount[],
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await addAccountGroupsService.addAccountGroups({
        account_group_name: accountGroupName,
        registered_accounts: registeredAccounts,
      });

      // 成功時の処理
      onTapCompleteModal();
    } catch (error) {
      // エラーハンドリング
      console.log("addAccountGroups:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    accountGroupName,
    setAccountGroupName,
    isActivateCreateButton,
    setIsActivateCreateButton,
    registeredAccounts,
    setRegisteredAccounts,
    check,
    setCheck,
    onChangeGroupName: errorHandledSync(onChangeGroupName, setError),
    onChangeCreateButtonState: errorHandledSync(onChangeCreateButtonState, setError),
    onTapCheckBox: errorHandledSync(onTapCheckBox, setError),
    addAccountGroups: errorHandledAsync(addAccountGroups, setError),
  };
};
